<template>
  <div
    class="service"
    v-show="show">
    <div v-if="show && !isQiYuReady" class="service__loading">
      <p class="service__loading__tip">在线客服加载中</p>
    </div>
    <iframe
      ref="customerServiceFrame"
      class="service__frame"
      frameborder="0"
      v-if="show&&qiYuUrl"
      v-show="isQiYuReady"
      :src="qiYuUrl">
    </iframe>
  </div>
</template>

<script>
const qiyuBaseUrl = `https://app.xueersi.com/polymerh5/app/#/chat?sysNum=4a1c52959a974dd497260f4e0d50f1c9&channelFlag=${window.channelFlag || 2}`
export default {
  name: 'CustomerService',
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          key: 12
        }
      }
    }
  },
  data () {
    return {
      show: false,
      isQiYuReady: false,
      qiYuUrl: ''
    }
  },
  watch: {
    show (val) {
      if (val) {
        let paramsStr = ''
        Object.keys(this.params).forEach(key => {
          paramsStr += `&${key}=${this.params[key]}`
        })
        this.qiYuUrl = qiyuBaseUrl + paramsStr
        console.log(this.qiYuUrl)
        this.$nextTick(() => {
          this.initFrame()
        })
      } else {
        this.qiYuUrl = ''
      }
    }
  },
  methods: {
    initFrame () {
      const iframe = this.$refs.customerServiceFrame
      if (iframe.attachEvent) { // ie
        iframe.attachEvent('onload', () => {
          this.isQiYuReady = true
          window.addEventListener('message', (e) => {
            if (e.data.indexOf('ACK') === 0) return
            // 点击七鱼客服面板最小化按钮
            if (e && e.data) {
              const data = this.parseJSON(e.data)
              if (data && data.closeChat) {
                this.show = false
              }
            }
          }, false)
        })
      } else {
        iframe.onload = () => {
          this.isQiYuReady = true
          window.addEventListener('message', (e) => {
            if (e.data.indexOf('ACK') === 0) return
            // 点击七鱼客服面板最小化按钮
            if (e && e.data) {
              const data = this.parseJSON(e.data)
              if (data && data.closeChat) {
                this.show = false
              }
            }
          }, false)
        }
      }
    },
    parseJSON (str) {
      try {
        const obj = JSON.parse(str)
        return obj
      } catch (error) {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.service {
  box-shadow: rgba(15, 66, 76, 0.25) 0px 0px 24px 0px;
  border-radius: 5px 5px 0px 0px;
  position: fixed;
  height: 540px;
  overflow: hidden;
  z-index: 2147483647;
  border: none;
  bottom: 0px;
  right: 100px;
  width: 360px;
  display: block;
  background-color: #fff;
  &__loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
    background-image: url('./img/loading.svg');
    background-size: 100px 100px;
    &__tip {
      text-align: center;
      font-size: 14px;
    }
  }
  &__frame {
    width: 100%;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// module/order/src/components/CustomerService/CustomerService.vue